const translation = {
  daysInWeek: {
    Wed: 'Quarta-feira',
    Tue: 'Terça-feira',
    Sun: 'Sol',
    Thu: 'Quinta-feira',
    Fri: 'Sexta',
    Sat: 'Sábado',
    Mon: 'Mon',
  },
  months: {
    May: 'Maio',
    February: 'Fevereiro',
    April: 'abril',
    September: 'Setembro',
    March: 'Março',
    December: 'Dezembro',
    November: 'Novembro',
    October: 'Outubro',
    July: 'Julho',
    August: 'Agosto',
    June: 'junho',
    January: 'Janeiro',
  },
  operation: {
    pickDate: 'Escolher Data',
    ok: 'OK',
    cancel: 'Cancelar',
    now: 'Agora',
  },
  title: {
    pickTime: 'Escolha o Horário',
  },
  defaultPlaceholder: 'Escolha um horário...',
}

export default translation
